import type { EmotionBucket, EmotionProbabilities, EngagementProbabilities } from '@/types/emotion';

const bucketMap: Record<EmotionBucket, Array<keyof EmotionProbabilities>> = {
  engaged: ['happy', 'surprise'],
  confused: ['fear', 'angry', 'disgust'],
  disengaged: ['sad'],
  neutral: ['neutral']
};

export const mapToEngagementBuckets = (emotions: EmotionProbabilities): EngagementProbabilities => {
  const totals: Record<EmotionBucket, number> = {
    engaged: 0,
    confused: 0,
    disengaged: 0,
    neutral: 0
  };

  for (const [bucket, mapped] of Object.entries(bucketMap) as Array<[EmotionBucket, Array<keyof EmotionProbabilities>]>) {
    totals[bucket] = mapped.reduce((sum, label) => sum + (emotions[label] ?? 0), 0);
  }

  const sum = Object.values(totals).reduce((acc, value) => acc + value, 0) || 1;
  return Object.fromEntries(Object.entries(totals).map(([key, value]) => [key, value / sum])) as EngagementProbabilities;
};

export const describeBucket = (bucket: EmotionBucket) => {
  switch (bucket) {
    case 'engaged':
      return 'Happy / Surprise';
    case 'confused':
      return 'Fear / Anger / Disgust';
    case 'disengaged':
      return 'Sad';
    default:
      return 'Neutral';
  }
};

